import styled from 'styled-components'


export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 22px;
`

export const DialogTitleIcon = styled.span`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-weight: 700;
  justify-content: center;
  min-height: 24px;
  min-width: 24px;

  ::before {
    content:'X';
  }
`

export const DialogTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px;
  font-size: 18px;
`

export const DialogTitleText = styled.span`
  color: #3B4A5D;
  font-weight: 700;
`
export const ContentChart = styled.div`
  background: #FFFF;
  padding: 10px;
  left: 588px;
  position: absolute;
  width: 700px;

  @media (max-width: 1320px) {
    width: calc(100vw - 620px);
  }

  @media (max-width: 620px) {
    display: none;
  }
`
